import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const FaqContainer = styled('div')(({ theme }: { theme?: Theme }) => ({
  marginLeft: '2px',
  marginRight: '2px',
  '& .readings101-btn': {
    padding: '12px 24px 10px',
    fontSize: '14px',
    fontWeight: 400,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      border: '1px solid #5fcac8',
      color: '#5fcac8',
      backgroundColor: 'transparent'
    }
  },
  [theme.breakpoints.up('sm')]: {
    marginLeft: '4px',
    marginRight: '4px',
    '& .readings101-btn': {
      fontSize: '16px',
      padding: '16px 24px 14px',
      marginTop: '10px'
    }
  }
}));

export const FaqContent = styled('div')({
  marginTop: '20px'
});

export const StyledList = styled('ul')(({ theme }: { theme?: Theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  [theme.breakpoints.up('sm')]: {
    paddingRight: '10px'
  }
}));

export const StyledLink = styled('a')(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.primary.dark,
  textDecoration: 'none',
  '&:visited': {
    color: theme.palette.primary.main
  },
  '&:hover': {
    color: theme.palette.primary.main
  }
}));

export const StyledItem = styled('li')({
  position: 'relative',
  marginLeft: '20px',
  marginBottom: '10px',
  fontSize: '16px',
  '&::before': {
    position: 'absolute',
    left: '-20px',
    content: '""',
    width: '6px',
    height: '6px',
    backgroundColor: 'teal',
    lineHeight: 0,
    borderRadius: '50%',
    transform: 'perspective(6px)',
    verticalAlign: 'top',
    marginTop: '7px'
  }
});
